import { useId } from "react";
import { ICheckbox } from "../../interfaces";

export const GaCheckbox = ({ isChecked, onChange, onKeyDown, label, disabled, tabIndex }: ICheckbox) => {
    const id = useId();

    return (
        <div className="ga-checkbox">
            <input type="checkbox" 
                className="ga-checkbox__native" 
                id={id}
                checked={isChecked} 
                onChange={(e) => onChange(e.target.checked)} 
                onClick={(e) => e.stopPropagation()} 
                onKeyDown={onKeyDown}
                disabled={disabled}
                tabIndex={tabIndex ? tabIndex : 0} />
            <div className="ga-checkbox__marker">
                <svg viewBox="0 0 16 16" fill="none" className="ga-checkbox__marker__indicator-checked">
                    <path d="M4 9L6 11L12 5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                </svg>
                <svg viewBox="0 0 16 16" fill="none" className="ga-checkbox__marker__indicator-indeterminate">
                    <path d="M4 8H6.13333H12" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                </svg>
            </div>
            <label className="ga-checkbox__label" htmlFor={id}>{label}</label>
        </div>
    )
}